import React from 'react';
import { CardList, Badge, Avatar } from '@/components/ui';
import type { AuditLog } from '../types/company.types';
import { getAuditAction } from '@/utils/status';
import { formatDateTime } from '@/utils/format';

interface AuditLogsMobileListProps {
  logs: AuditLog[];
  isLoading?: boolean;
}

export function AuditLogsMobileList({ logs, isLoading }: AuditLogsMobileListProps) {
  return (
    <CardList className="grid grid-cols-1 gap-4">
      {isLoading ? (
        Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-32 bg-slate-50 animate-pulse rounded-2xl" />
        ))
      ) : logs.length === 0 ? (
        <div className="col-span-full py-12 text-center text-slate-400 bg-slate-50/50 rounded-2xl border border-dashed border-slate-200">
          Chưa có nhật ký hoạt động nào.
        </div>
      ) : (
        logs.map((log) => {
          const action = getAuditAction(log.action_code);
          return (
            <div key={log.id} className="p-4 bg-white border border-slate-100 rounded-2xl shadow-sm space-y-3">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-2">
                  <Avatar
                    src={log.actor_avatar || undefined}
                    name={log.actor_name || 'Hệ thống'}
                    size="sm"
                  />
                  <div>
                    <h4 className="text-sm font-bold text-slate-900">{log.actor_name || 'Hệ thống'}</h4>
                    <p className="text-xs text-slate-500 font-mono">{log.ip_address}</p>
                  </div>
                </div>
                <Badge variant={action.variant as any} className="text-xs font-bold ">
                  <i className={`${action.icon} mr-1`} />
                  {action.label}
                </Badge>
              </div>

              <p className="text-sm text-slate-600 line-clamp-2">{log.summary}</p>

              <div className="flex justify-between items-center pt-2 border-t border-slate-50">
                <span className="text-xs text-slate-400 font-medium tracking-wider">
                  {log.module_code} / {log.entity_type}
                </span>
                <span className="text-xs text-slate-500">
                  {formatDateTime(log.created_at)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </CardList>
  );
}
